export default __webpack_public_path__ + "media/images/gestion-d2d83afa983890cc96e0969c6a5f8e6d.png";